import React from 'react';
import ReactDOM from 'react-dom';

class MapLocation extends React.Component {
  constructor(props) {
    super(props);
    const { lat, lng } = this.props.initialCenter;
    this.state = {
      currentLocation: {
        lat: lat,
        lng: lng
      }
    };

  }


  //verifica si esta cargada la api
  componentDidUpdate(prevProps, prevState) {
      if (prevProps.google !== this.props.google) {
        this.loadMap();
      }
      if (prevState.currentLocation !== this.state.currentLocation) {
        this.recenterMap();
      }
    }

    //maneja la instancia cuando el mapa ya se ha cargado y recupra la ubicacion actual
    componentDidMount() {
       if (this.props.centerAroundCurrentLocation) {
         if (navigator && navigator.geolocation) {
           navigator.geolocation.getCurrentPosition(pos => {
             const coords = pos.coords;
             //console.log("coords",coords);
             this.setState({
               currentLocation: {
                 lat: coords.latitude,
                 lng: coords.longitude
               }
             });
           });
         }
       }
       this.loadMap();

     }

    // solo se llama cuando se actualiza currentLocation
    recenterMap() {
       const map = this.map;
       const current = this.state.currentLocation;
       const google = this.props.google;
       const maps = google.maps;

       if (map) {
         let center = new maps.LatLng(current.lat, current.lng);
         map.panTo(center);
       }
     }

     //solo se llama después de que el componente se ha procesado
    loadMap() {
        if (this.props && this.props.google) {
          // checks if google is available
          //console.log("props: ",this.props);
          const { google } = this.props;
          const maps = google.maps;
          const mapRef = this.refs.map;

          // reference to the actual DOM element
          const node = ReactDOM.findDOMNode(mapRef);

          let { zoom } = this.props;
          const { lat, lng } = this.state.currentLocation;
          const center = new maps.LatLng(lat, lng);
          const mapConfig = Object.assign(
            {},
            {
              center: center,
              zoom: zoom,
              streetViewControl: false,
              mapTypeControl: false,
              styles: [
                 {
                     featureType: "poi.business",
                     stylers: [{ visibility: "off" }]
                 }
             ]
            }
          );
          // maps.Map() is constructor that instantiates the map
          this.map = new maps.Map(node, mapConfig);
        }
      }

      renderChildren() {
       const { children } = this.props;
       if (!children) return;

       return React.Children.map(children, c => {
         if (!c) return;

         return React.cloneElement(c, {
           map: this.map,
           google: this.props.google,
           mapCenter: this.state.currentLocation

         });
       });
     }

     render() {
         const mapStyles = {
             map: {
                 position: 'absolute',
                 width: '100%',
                 height: '80%'
             }
         };

        const style = Object.assign({}, mapStyles.map);
        return (
            <div className="row">
                <div className="map" style={style} ref="map">
                  Loading map...
                  {this.renderChildren()}
                </div>
            </div>
        );
    }

}


export default MapLocation;

// centerAroundCurrentLocation establece una posiscion en caso que no se pueda encontrar la ubicacion actual
MapLocation.defaultProps = {
  //zoom: 15,
  initialCenter: {
    lat: 18.714833,
    lng: -99.267500
    },
  centerAroundCurrentLocation: false,
  visible: true,
};
